<template>
  <v-sheet>
    <choose-teacher
      v-if="!teacher"
      v-model="teacher"
      @selected="changeTeacher"
    />
    <div class="text-h5 mb-2" v-else>
      Adding schedule for {{ teacher.firstName  }} {{ teacher.lastName  }}
      <v-btn class="ma-2" @click="teacher = null">Change Teacher</v-btn>
    </div>

    <teacher-schedule-form
      :key="timestamp"
      :teacher.sync="teacher"
      v-model="schedule"
      @clickedSave="saveSchedule"
      v-if="teacher"
    />
  </v-sheet>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
const ChooseTeacher = () => import("@/components/teacher/ChooseTeacher.vue");
const TeacherScheduleForm = () =>
  import("@/components/teacher/TeacherScheduleForm.vue");

export default {
  components: { TeacherScheduleForm, ChooseTeacher },

  data: () => ({
    teacher: null,
    schedule: {},
    timestamp: Date.now()
  }),
  computed: {
    ...mapGetters(["navState", "isAppLoading", "currentUser"])
  },
  methods: {
    ...mapActions([
      "hideDialog",
      "addMessage",
      "addErrorMessage",
      "addSuccessMessage"
    ]),
    changeTeacher(teacher) {
      console.log("changing teacher...", teacher);
      this.getTeacher(teacher.id)
        .then((t) => {
          this.teacher = t;
          console.log("setting teacher to ", this.teacher)
        })
      this.timestamp = Date.now();
    },
    async getTeacher(teacherId) {
      if (teacherId) {
        const result = await this.$axios
          .get("teacher/getById", { params: { teacherId: teacherId } })

        const t = result.data.data;
        return t;
      } else {
        return null;
      }
    },
    saveSchedule() {
      this.schedule.teacherId = this.teacher.id;
      console.log("clicked save schedule", this.schedule);
      this.$axios
        .post("teacher/save-schedule", this.schedule)
        .then(resp => {
          console.log("Saved schedule", resp);

          this.hideDialog();
          this.teacher = null;
          this.schedule = null;
        })
        .catch(error => {
          console.log("Error saving staff schedule", error);
          this.addErrorMessage("Error saving staff schedule");
          this.teacher = null;
          this.schedule = null;
        });
    }
  }
};
</script>

<style></style>
